export { SkeletonItem } from './styled';
